import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const FeedSkeleton = ({ count = 3 }) => {
  return (
    <div style={{ width: '100%', maxWidth: 1000, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 }}>
      {/* Create Post Card Skeleton */}
      <Card
        bordered
        style={{
          borderRadius: 6,
          borderColor: '#e8e8e8',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
          marginBottom: 8
        }}
        bodyStyle={{ padding: '16px 20px' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <Skeleton.Avatar active size={40} shape="circle" />
          <div style={{ flex: 1 }}>
            <Skeleton.Input active block style={{ height: 38, borderRadius: 4 }} />
          </div>
          <Skeleton.Button active size="small" style={{ width: 80, height: 32, borderRadius: 4 }} />
        </div>
      </Card>

      {/* Section Header Skeleton */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '16px 4px 8px 4px' }}>
        <Skeleton.Input active style={{ width: 180, height: 24, borderRadius: 4 }} />
        <Skeleton.Button active size="small" style={{ width: 36, height: 20, borderRadius: 10 }} />
      </div>

      {/* Feed Post Skeletons */}
      {Array.from({ length: count }).map((_, idx) => (
        <Card
          key={'feed_skel_' + idx}
          bordered
          style={{
            borderRadius: 6,
            borderColor: '#e8e8e8',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
            marginBottom: 14
          }}
          bodyStyle={{ padding: '20px 24px' }}
        >
          {/* Post Header: Avatar, Name, Tag, Date */}
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Skeleton.Avatar active size={42} shape="circle" />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Skeleton.Input active size="small" style={{ width: 180, height: 16, borderRadius: 3 }} />
                  <Skeleton.Input active size="small" style={{ width: 100, height: 16, borderRadius: 3 }} />
                </div>
                <Skeleton.Input active size="small" style={{ width: 120, height: 12, borderRadius: 3 }} />
              </div>
            </div>
            <Skeleton.Button active size="small" style={{ width: 24, height: 24, borderRadius: 4 }} />
          </div>

          {/* Post Content Lines */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 18 }}>
            <Skeleton.Input active block style={{ height: 15, borderRadius: 3 }} />
            <Skeleton.Input active style={{ width: '94%', height: 15, borderRadius: 3 }} />
            <Skeleton.Input active style={{ width: '70%', height: 15, borderRadius: 3 }} />
          </div>

          {/* Attachments Skeleton */}
          <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
            <Skeleton.Button active size="small" style={{ width: 140, height: 32, borderRadius: 4 }} />
            <Skeleton.Button active size="small" style={{ width: 160, height: 32, borderRadius: 4 }} />
          </div>

          {/* Post Footer Actions */}
          <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Skeleton.Button active size="small" style={{ width: 120, height: 28, borderRadius: 4 }} />
            <Skeleton.Input active size="small" style={{ width: 60, height: 14, borderRadius: 3 }} />
          </div>
        </Card>
      ))}
    </div>
  );
};

export default FeedSkeleton;
